import React from 'react';
import { Link } from 'react-router-dom';
import singlePageStyles from '../common/SinglePage.module.scss';
import classNames from 'classnames';
import Layout from '../global/Layout';
import { Button } from '@solid/shared/ui';
import { useTranslation } from 'react-i18next';

const ConfirmEmailPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Layout>
      <div className={classNames('wrapper', singlePageStyles.wrapper)}>
        <h1>{t('pages.confirmEmail.title')}</h1>
        <p>{t('pages.confirmEmail.text')}</p>
        <Link to='/login'>
          <Button>{t('pages.confirmEmail.button')}</Button>
        </Link>
      </div>
    </Layout>
  );
};

export default ConfirmEmailPage;
